module.exports = __webpack_public_path__ + "static/assets/3dd8f573267d99448c62fd87bf0e3591.svg";